(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-filter"]) return;
  try {
    

    // 1. ФИЛЬТР ОБЪЕМА ДВИГАТЕЛЕЙ (ENGINE FILTER)
    waitForElm('.CollectionList-drwMlz').then((elm) => {
 
        let engineAll = document.querySelector('#engineAll');
        let engine125 = document.querySelector('#engine125');
        let engine160 = document.querySelector('#engine160');
        let engine350 = document.querySelector('#engine350');

        let allEngines = document.querySelectorAll('.Collection-hcKCxl'); 
        
        let booqable125;
        let booqable160;
        let booqable350;
        let booqableAll;

        allEngines.forEach((el) => {
            let nameDiv = el.querySelector('div');
            if (!nameDiv) return;
            
            let text = nameDiv.textContent.trim();
            
            if(text === '110 cc - 125 cc') {
                booqable125 = el;
            }
            if(text === '150 cc - 160 cc') {
                booqable160 = el;
            }
            if(text === '300 cc - 350 cc') {
                booqable350 = el;
            }
            if(text === 'All') {
                booqableAll = el;
            }
        });

        if (engine125 && booqable125) {
            engine125.addEventListener('click', () => { booqable125.click(); });
        }
        if (engine160 && booqable160) {
            engine160.addEventListener('click', () => { booqable160.click(); });
        }
        if (engine350 && booqable350) {
            engine350.addEventListener('click', () => { booqable350.click(); });
        }
        if (engineAll && booqableAll) {
            engineAll.addEventListener('click', () => { booqableAll.click(); });
        }
    });


    // 2. УМНАЯ СОРТИРОВКА ПО ФИНАЛЬНОЙ ЦЕНЕ (PRICE SORTING)
    window.currentSortDirection = 'asc'; 

    function sortProducts() {
        let grid = document.querySelector('.booqable-product-list-grid');
        if (!grid) return;
        
        let products = Array.from(grid.querySelectorAll('.booqable-product'));

        products.sort((a, b) => {
            let priceAEl = a.querySelector('.bq-price');
            let priceBEl = b.querySelector('.bq-price');
            
            let priceA = priceAEl ? parseFloat(priceAEl.textContent.replace(/[^0-9.]/g, '')) : 0;
            let priceB = priceBEl ? parseFloat(priceBEl.textContent.replace(/[^0-9.]/g, '')) : 0;

            if (window.currentSortDirection === 'asc') {
                return priceA - priceB; 
            } else {
                return priceB - priceA; 
            }
        });

        products.forEach(product => grid.appendChild(product));
    }

    let sortTag = document.querySelector('#sort-tag');
    let sortLower = document.querySelector('#price-sort-lower');
    let sortHigher = document.querySelector('#price-sort-higher');

    if (sortLower) {
        sortLower.addEventListener('click', () => {
            sortTag.innerText = sortLower.textContent;
            window.currentSortDirection = 'asc';
            sortProducts();
        });
    }

    if (sortHigher) {
        sortHigher.addEventListener('click', () => {
            sortTag.innerText = sortHigher.textContent;
            window.currentSortDirection = 'desc';
            sortProducts();
        });
    }


    // 3. СЧЕТЧИК ПРЕДЛОЖЕНИЙ И НАБЛЮДАТЕЛЬ ЗА ОБНОВЛЕНИЕМ СТРАНИЦЫ
    function updateOfferCount() {
        let availableBikes = document.querySelectorAll('.bq-available');
        let offers = document.querySelector('#offers');
        
        if (offers) {
            offers.innerText = availableBikes.length;
        }
    }

    waitForElm('.booqable-product-list-wrapper').then((elm) => {
        
        setTimeout(() => {
            sortProducts();
            updateOfferCount();
        }, 600);

        const targetNode = elm;
        const config = { attributes: false, childList: true, subtree: true };
    
        const callback = (mutationList, observer) => {
            observer.disconnect(); // Стопаем слежку на время перестановки
            
            sortProducts();        // Сортируем
            updateOfferCount();    // Считаем
            
            observer.observe(targetNode, config); // Включаем слежку обратно
        }; 
    
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-custom"] && !Shopify.designMode) return;
  try {
    

    // display input form or success tag
    document.addEventListener("DOMContentLoaded", () => {
        var posted = 'customer_posted=true';
        var url = window.location.href;
        if(url.includes(posted) ||  url.includes('form_type=customer')) {
            document.querySelector('.subscribed-wrapper').classList.add('show');
        } else {
            document.querySelector('.subscribe-custom__form-wrapper').classList.add('show');
        }
    });

  
  } catch(e) { console.error(e); }
})();
})();
